<template>
    <div>
        <v-toolbar flat color="white">
        <v-spacer></v-spacer> 
        <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                max-width="50px"
                class="pa-3"
                clearable
              ></v-text-field> 
              <v-btn round color="primary" @click="addItem()">Add Workflow</v-btn></v-toolbar>
        <v-data-table 
            :loading="isLoading"
            :search="search"
            :items="workflows" :headers="headers">
            <template v-slot:items="props">
                <td class="text-xs-center">
                    <v-icon @click="editItem(props.item)">edit</v-icon>
                    <v-icon @click="deleteItem(props.item)">delete</v-icon>
                </td>
                <td class="text-xs-center">
                    {{props.item.name}}
                </td>
            </template>
        </v-data-table>
        <v-dialog v-model="addModal" persisitent max-width="750px">
            <v-card>
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">Add Workflow</h3>
                </v-toolbar>
                <v-card-text mx-3>
                    <v-layout mx-3>
                    <v-flex xs6>
                    <v-layout mx-3>
                        <v-text-field label="Name" v-model="item.name"></v-text-field>
                     </v-layout>
                  </v-flex>
                    </v-layout>
                <!--  <v-layout mx-3>
                    <v-flex xs12>
                     <div>
                        <h3 class="grey--text">Category Items:</h3>
                        <v-layout mx-3>
                            <v-text-field label="Name" v-model="name"></v-text-field>
                            <v-text-field label="Code" v-model="code"></v-text-field>
                            <v-icon @click="item.ticketCategoryItems.push({name: name, code: code}), name='', code=''" color="primary">add_circle</v-icon>
                        </v-layout>
                        <v-flex xs12 v-for="subItem in item.ticketCategoryItems" :key="subItem.name">
                            <v-layout mx-2>
                                <v-flex xs4><h3 class="grey--text">{{subItem.name}}</h3></v-flex>
                                <v-flex xs4><h3 class="grey--text">{{subItem.code}}</h3></v-flex>
                                <v-flex xs4><h3 class="grey--text">{{subItem.colour}}</h3></v-flex>
                                <v-flex xs4><v-icon @click="item.ticketCategoryItems.splice(item.ticketCategoryItems.indexOf(subItem), 1)">delete</v-icon></v-flex>
                                
                            </v-layout>
                        </v-flex>

                    </div>
                    </v-flex>
                    </v-layout>-->
                   
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn round color="primary" class="white--text" @click="item={}, addModal=false">Cancel</v-btn>
                        <v-btn v-if="item.name" round color="primary" class="white--text" @click="createWorkflow()">Save</v-btn>
                        <v-btn round v-else disabled>Save</v-btn>

                    </v-layout> 
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editModal" persisitent max-width="750px">
            <v-card>
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">Edit Workflow</h3>
                </v-toolbar>
                <v-card-text mx-3>
                   <v-layout mx-3>
                    <v-flex xs6>
                    <v-layout mx-3>
                        <v-text-field label="Name" v-model="item.name"></v-text-field>
                       </v-layout>
                  </v-flex>
                    </v-layout>
                 <!--  <v-layout mx-3>
                    <v-flex xs12>
                     <div>
                        <h3 class="grey--text">Category Items:</h3>
                        <v-layout mx-3>
                            <v-text-field label="Name" v-model="name"></v-text-field>
                            <v-text-field label="Code" v-model="code"></v-text-field>
                            <v-icon @click="item.ticketCategoryItems.push({name: name, code: code}), name='', code=''" color="primary">add_circle</v-icon>
                            
                        </v-layout>
                        <v-flex xs12 v-for="subItem in item.ticketCategoryItems" :key="subItem.name">
                            <v-layout mx-2>
                                <v-flex xs4><h3 class="grey--text">{{subItem.name}}</h3></v-flex>
                                <v-flex xs4><h3 class="grey--text">{{subItem.code}}</h3></v-flex>
                                <v-flex xs4><v-icon @click="removeTicketCategoryItem(subItem)">delete</v-icon></v-flex>
                            </v-layout>
                        </v-flex>

                    </div>
                    </v-flex>
                    </v-layout>-->
                   
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn round color="primary" class="white--text" @click="item={}, editModal=false">Cancel</v-btn>
                        <v-btn v-if="item.name" round color="primary" class="white--text" @click="updateWorkflow()">Save</v-btn>
                        <v-btn round v-else disabled>Save</v-btn>

                    </v-layout> 
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Api from '@/services/Api.js'
export default {
    data(){
        return {
            isLoading: true,
            search: '',
            addModal: false,
            editModal: false,
            item: {
                name: ''},
            
            workflows:[],
            ticketCategoryItems:[],
            ticketCatItemId:null,
            ticketCategoryItemWorkflows:[],
            ticketCategoryItemWorkflowsId:null,
            iconOptions: ['account_circle', 'build', 'assessment', 'grade', 'devices', 'merge_type', 'device_hub', 'toys', 'home_work'],
            headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
      }]
        }
    },
    created(){
        this.fetchWorkflows()
        this.fetchTicketCategoryItems()
    },
    methods: {
        fetchWorkflows(){
                   Api()
                    .get('/workflow').then(response=>{
                        this.workflows=response.data
                    }).then(this.isLoading=false)
        },
        fetchTicketCategoryItems(){
            Api()
            .get('/ticketCategoryItem')
            .then(response=>{
                this.ticketCategoryItems = response.data
            })
        },
        addItem(){
            if(this.authCreate(this.$store.state.currentRoute)){
                this.item={}
                this.ticketCatItemId=null
                this.addModal=true
            }            
        },
        async createWorkflow(){
                    Api()
                    .post('/workflow',{
                        name: this.item.name
                    }).then(response=>{
                        this.fetchWorkflows()                        
                    })
                    
                    this.addModal=false
                    this.item={}
            },
           updateWorkflow(){
                Api()
                    .put('/workflow/'+this.item.id, {
                        name: this.item.name
                    }).then(response=>{                     
                        this.fetchWorkflows()
                        this.editModal=false                   
                    }) 
                        this.editModal=false   
            },
            editItem(item){
                if(this.authUpdate(this.$store.state.currentRoute)){
                    this.editModal=true
                     this.item = Object.assign({}, item);
                }
            },
            deleteItem(item){
                if(this.authDelete(this.$store.state.currentRoute)){
                    confirm('Are you sure you want to delete this item?')&&
                    Api()
                    .put('/workflow/'+item.id,{
                        isActive: false,
                        isDeleted: true
                    })
                    .then(response=>{
                        this.fetchWorkflows()   
                    })
                }
            },
            removeTicketCategoryItem(item){
                let index = this.item.ticketCategoryItems.indexOf(item)
                this.item.ticketCategoryItems.splice(index, 1)
                Api()
                .put('/ticketCategoryItem/'+item.id,{
                    isActive: false,
                    isDeleted: true
                })

            }
            
    }
}
</script>